import { basePrintStyles } from "../shared/basePrintStyles";
import { escapeHtml } from "../shared/escapeHtml";
import { downloadPrintDocument } from "./downloadPrintDocument";
import { openPrintWindow } from "./openPrintWindow";

export const PRINT_DOCUMENT_CREATED_EVENT = "oceanlogix:print-document-created";

const localOutputStyles = `
  .local-output-status {
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 10px 16px;
    background: #edf7f0;
    border-bottom: 1px solid #b8d8c0;
    color: #173d21;
    font: 600 13px/1.4 Arial, sans-serif;
  }

  .local-output-status p { margin: 0; }
  .local-output-download {
    flex: 0 0 auto;
    border: 1px solid #1f6f3b;
    border-radius: 4px;
    padding: 7px 10px;
    background: #fff;
    color: #14552c;
    cursor: pointer;
    font: inherit;
  }

  .local-output-download:hover { background: #e3f1e7; }

  @media print {
    .local-output-status { display: none; }
  }
`;

const createLocalOutputToolbar = () => `
  <section class="local-output-status" role="status">
    <p>Created locally. This document has not been synchronized.</p>
    <button type="button" class="local-output-download" data-download-document>
      Download HTML
    </button>
  </section>
`;

const attachDownloadHandler = (printWindow, title, html) => {
  if (typeof printWindow.document.querySelector !== "function") return;

  const downloadButton = printWindow.document.querySelector(
    "[data-download-document]"
  );

  if (!downloadButton) return;

  downloadButton.addEventListener("click", () => {
    downloadPrintDocument({ title, html });
  });
};

export const createPrintDocumentHtml = ({ title, styles = "", body }) => `
  <!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>${escapeHtml(title)}</title>
      <style>
        ${basePrintStyles}
        ${styles}
        ${localOutputStyles}
      </style>
    </head>
    <body>
      ${createLocalOutputToolbar()}
      ${body}
    </body>
  </html>
`;

export const renderPrintDocument = ({
  title,
  styles = "",
  body,
  templateId,
  viewModel,
  onAfterRender,
}) => {
  let printWindow;

  try {
    printWindow = openPrintWindow(title);
  } catch {
    window.alert(
      "The print window was blocked by your browser. Please allow popups and try again."
    );
    return null;
  }

  // Register before writing because closing a small document can complete quickly.
  printWindow.onload = () => {
    attachDownloadHandler(printWindow, title, html);

    if (typeof onAfterRender === "function") {
      onAfterRender(printWindow);
    }

    printWindow.focus();
    printWindow.print();
  };

  const html = createPrintDocumentHtml({ title, styles, body });
  printWindow.document.write(html);
  printWindow.document.close();

  if (templateId) {
    window.dispatchEvent(
      new CustomEvent(PRINT_DOCUMENT_CREATED_EVENT, {
        detail: { title, html, templateId, viewModel },
      })
    );
  }

  return printWindow;
};
